import React = require('react');
import { PostcodeLookup } from '../../../Components/PostcodeLookup';
import { Col, Row } from 'react-bootstrap';
import { Field } from 'redux-form';
import FieldFormControl from '../../../../../../components/FieldFormControl';
import { isEmail, isPhone, isRequired } from '../../../../../../util/validators';
import { AdmiralCard } from '../../../Components/AdmiralCard';
import { useState } from 'react';
import { ITraveller } from '../../../../../../data/api/models';
import { get, head } from 'lodash';

interface ILeadTravellerDetailProps {
  travellers: ITraveller[];
}

export const LeadTravellerDetails = (props: ILeadTravellerDetailProps) => {

  const { travellers } = props;

  const [editable, setEditable] = useState(false);
  const leadTraveller = head(travellers);

  const onChangeEdit = (value) => {
    setEditable(value)
  }

  const renderNotEditable = () => {
    return (
      <>
        <div className={'non-editable-rows'}>
          <div className={'box--half'}>Address</div>
          <div className={'box--half'}>
            <div>
              {get(leadTraveller, 'address.line1', '')}
            </div>
            <div>
              {get(leadTraveller, 'address.town', '')}
            </div>
            <div>
              {get(leadTraveller, 'address.postcode', '')}
            </div>
          </div>
        </div>
        <div className={'non-editable-rows'}>
          <div className={'box--half'}>Email</div>
          <div className={'box--half'}>{get(leadTraveller, 'email', '')}</div>
        </div>
        <div className={'non-editable-rows'}>
          <div className={'box--half'}>Phone</div>
          <div className={'box--half'}>{get(leadTraveller, 'phone', '')}</div>
        </div>
      </>

    )
  }

  const renderEditable = () => {
    return (
      <>
        <PostcodeLookup {...props} basePath={'travellers[0].address'} title={'Postcode'}/>
        <Row className={'adm-form-group'}>
          <Col xs={6} className={'full-width-xs'}>Email address</Col>
          <Col xs={6} className={'full-width-xs'}>
            <Field
              name={`travellers[${0}].email`}
              type="email"
              component={FieldFormControl}
              validate={[isRequired, isEmail]}
              autocomplete="new-password"
            />
          </Col>
        </Row>
        <Row className={'adm-form-group'}>
          <Col xs={6} className={'full-width-xs'}>Phone number</Col>
          <Col xs={6} className={'full-width-xs'}>
            <Field
              name={`travellers[${0}].phone`}
              inputmode="numeric"
              type="text"
              component={FieldFormControl}
              validate={[isRequired, isPhone]}
              autocomplete="new-password"
            />
          </Col>
        </Row>
      </>
    )
  }

  return (
    <AdmiralCard
      handleEdit={onChangeEdit}
      showSaveButton={true}
      icon={'person.svg'}
      title={'Your contact details'}
      forceTitle={true}
      noEditModeDisplay={true}
      noPadding={!editable}
      editMode={editable}>
      {editable && (
        <>
          {renderEditable()}
        </>
      )}
      {!editable && (
        <>
          {renderNotEditable()}
        </>
      )}
    </AdmiralCard>
  )
}
